export const API = {
  // auth — cùng endpoint với app HP-Media (src/app/library/networking/api.ts). Mọi route dưới
  // đây trừ logout/status đều công khai; lỗi 4xx/5xx đổi sang tiếng Việt bằng
  // layouts/auth/auth-errors.ts.
  login: 'auth/login', // POST { username: email, password } → 200 "OK" + cookie phiên
  logout: 'auth/logout', // POST, cần phiên
  getUserInfo: 'auth/status', // GET, cần phiên → user (roles "ADMIN,MOD"...)
  // POST { code } → 200 { ok, to } + cookie phiên (trang /sso, mở từ app: Tôi → Trang quản trị)
  adminHandoffRedeem: 'auth/admin-handoff/redeem',
  // POST { email, nickName, phoneNumber, username?, password } → gửi mã 4 số qua email.
  // 409 'User already exists' (email) / 'Tiktok ID already exists'; 5xx khi gửi mail lỗi.
  register: 'auth/register',
  // POST { email, code } → { status: 'User verify done' }; 400 'Code Wrong with Email'.
  verifyUser: 'users/verify',
  // GET ?username=<TikTok ID> → 200 còn trống; 409 'User already exists' đã có người dùng.
  checkUsername: 'users/check',
  // POST { email } → 201; 400 'User not verify' khi email không có / chưa xác minh.
  forgotPassword: 'auth/forgot-password',
  // POST { email, code } → { status: 'ok' }; 400 'Code Wrong with Email'.
  verifyForgotCode: 'auth/verify/code-forgot',
  // POST { email, code, newPassword, confirmNewPassword } → { status: 'ok' }.
  updatePasswordForgot: 'auth/update-pass/forgot',

  changePassword: '/change-password',

  //upload-file
  uploadFile: '/image/storages',

  // user management
  users: '/users',
  createUser: '/users/create',
  deleteUsers: '/users/delete',
  editUser: '/users',
  checkUsers: '/users/check',
  searchUser: '/users/search',
  searchUserAdmin: '/users/search/admin',
  searchAgency: '/users/search-agency',
  agencyUpdate: '/users/agency-update',
  getListGroup: '/users/groups',
  // Hai route nhập cũ: trang quản trị không gọi nữa từ 29/09/2026 (chỉ còn file không dùng
  // pages/revenue-manager/component/ModalTiktokImport.tsx). Nhập file dùng dataImport* bên dưới.
  tiktokImportPreview: '/users/tiktok-import/preview',
  tiktokImportApply: '/users/tiktok-import/apply',
  // Nhập dữ liệu (file TikTok theo ngày / theo tháng) — hp-media-server-staging/src/data-import,
  // docs/nhap-du-lieu/DAC-TA-2026-09-29.md §8. ADMIN luôn được; MOD phải được Admin cấp quyền,
  // chưa có quyền → 409 DATA_IMPORT_NOT_ALLOWED (không 401/403).
  dataImportAccess: '/data-import/access', // GET → { canImport, isAdmin }, luôn 200
  dataImportPreview: '/data-import/preview',
  dataImportApply: '/data-import/apply',
  dataImportCalendar: '/data-import/calendar', // ?month=YYYY-MM
  dataImportMonths: '/data-import/months', // ?count=12 → trạng thái các tháng gần nhất
  dataImportLogs: '/data-import/logs', // + /:id/download (chỉ ADMIN)
  dataImportPermissions: '/data-import/permissions', // + /:userId (PUT, chỉ ADMIN)
  // Thưởng Online (docs/thuong-online/02-dac-ta-bang-data-creator.md §6). Lỗi quyền là 409 ONLINE_REWARD_*.
  onlineRewardAccess: '/online-reward/access', // GET → { canView, canEnter, isAdmin }, luôn 200
  onlineRewardGroups: '/online-reward/groups', // GET → tên Nhóm có trong file TikTok
  onlineRewardMonths: '/online-reward/months', // + /:month, /:month/creators/:uid, /:month/export, /:month/close, /:month/reopen
  onlineRewardItems: '/online-reward/items', // + /:id (PUT, DELETE), /:id/confirm, /:id/reject, /decide
  onlineRewardPolicies: '/online-reward/policies', // GET danh sách bản, POST tạo bản (ADMIN)
  onlineRewardPermissions: '/online-reward/permissions', // + /:userId (PUT { level: VIEW | ENTER | null }, ADMIN)
  // Báo giá thiết bị (docs/bao-gia-thiet-bi/01-dac-ta-2026-10-27.md §5). Lỗi quyền là 409 EQUIPMENT_*.
  equipmentQuoteAccess: '/equipment-quotes/access', // GET → { canUse, isAdmin, via }, luôn 200
  // Phân tích Creator (docs/phan-tich-creator/01-dac-ta-2026-10-06.md §6). Lỗi quyền là 409 ANALYTICS_*.
  analyticsAccess: '/analytics/access', // GET → { canView, scope, reason?, groups, months, isAdmin }, luôn 200
  analyticsOverview: '/analytics/overview', // GET ?month&groupId&kind
  analyticsCreators: '/analytics/creators', // GET ?month&groupId&kind&sort&dir&q&page&limit · + /:uid?month
  analyticsRecompute: '/analytics/recompute', // POST ?month (ADMIN)
  // Phí Agency (docs/phi-agency/01-cong-thuc-phi-agency.md) — chỉ ADMIN, lỗi quyền là 409 AGENCY_FEE_*.
  agencyFeeGroups: '/agency-fee/groups', // GET → tên Nhóm có trong file TikTok
  agencyFeeCreators: '/agency-fee/creators', // GET ?uids=1,2 → TikTok ID / Nhóm của từng UID
  agencyFeeMonths: '/agency-fee/months', // + /:month, /:month/export
  agencyFeePolicies: '/agency-fee/policies', // GET danh sách bản, POST tạo bản
  // Tra cứu KC (docs/tra-cuu-kc/): quyền như Nhập dữ liệu, thiếu quyền → 409 KC_LOOKUP_NOT_ALLOWED.
  kcLookupAccess: '/kc-lookup/access', // GET → { canUse }, luôn 200
  kcLookupMonths: '/kc-lookup/months', // GET ?count=12 → trạng thái các tháng
  kcLookupAgents: '/kc-lookup/agents', // GET ?months=a,b | ?from&to → email Đại diện
  kcLookupQuery: '/kc-lookup/query', // POST { ids, emails, mode, months | from+to, compare }
  kcLookupExport: '/kc-lookup/export', // POST → { token }; GET /:token → .xlsx (5 phút, một lần)
  kcLookupExtract: '/kc-lookup/extract', // POST file → các cột giống ID
  kcLookupGroups: '/kc-lookup/groups', // GET ?months= | ?from&to → Nhóm TikTok (cột D)
  kcLookupSearch: '/kc-lookup/search', // GET ?q=&months= → 20 Creator khớp TikTok ID / UID
  kcLookupHistory: '/kc-lookup/history', // GET 20 lần tra gần nhất của mình; DELETE (xoá hết) | /:id
  kcLookupLists: '/kc-lookup/lists', // GET (của mình + chia sẻ), POST; /:id GET, PUT, DELETE (chủ bộ / Admin)
  // Vấn đề dữ liệu (chỉ xem, ADMIN + MOD) — docs/nhap-du-lieu/DAC-TA-DOT-2-VAN-DE-DU-LIEU-2026-09-29.md §3.
  // + /summary · /departed · /missing · /renames · /unmatched (?page&limit&q → { items, total, page, limit })
  dataIssues: '/data-import/issues',
  // Chúc mừng Creator đạt mốc KC (ADMIN + MOD; PUT config chỉ ADMIN) — docs/chuc-mung-moc-kc/DAC-TA-2026-10-01.md §4.1.
  kcMilestonesAdmin: '/kc-milestones/admin', // GET ?month=YYYY-MM&scope=honor|all → { month, closed, asOf, scope, counts, config, summary, rows }
  kcMilestonesAdminCreators: '/kc-milestones/admin/creators', // PATCH { month, tiktokUid, hidden } → { ok }
  kcMilestonesAdminSync: '/kc-milestones/admin/sync', // POST { month } → { month, created, dropped, restored, pushed }
  kcMilestonesAdminConfig: '/kc-milestones/admin/config', // GET → config · PUT { homeEnabled?, pushEnabled?, homePosition?, showDiamonds?, showDays?, showHours?, showTrend?, milestones?, honorMin? }
  kcMilestonesAdminExclusions: '/kc-milestones/admin/exclusions', // GET → list · POST { query, note? } · DELETE /:uid (mọi tháng, theo UID)
  // GET → { tier, kinds, can: { KC_MANUAL, ... }, limits }. Trang Nhập dữ liệu chỉ hiện nút
  // "Sửa tay 1 dòng" khi can.KC_MANUAL là true (đặc tả đợt 2 §5).
  approvalsMe: '/approvals/me',

  //groups

  groups: '/groups/admin',
  createGroup: '/groups',
  searchGroup: '/groups/search',
  addUserToGroup: '/groups/add-user',
  domesticMembers: (id: number) => `/groups/${id}/domestic-members`,
  deleteDomesticGroup: (id: number) => `/groups/${id}/domestic`,
  userDomestic: '/users',

  //news
  news: '/news',
  updateNew: '/news',
  deleteNew: '/news/delete',

  //vote
  votes: '/votes/admin',
  listUser: '/votes',
  voteCreate: '/votes',
  updateVote: '/votes',
  voteVisibility: (id: number) => `/votes/${id}/visibility`,
  deleteVote: '/votes/delete',
  voteSearch: '/votes/search',
  userJoinVote: '/user-joins/event',
  deleteUserJoinVote: '/user-joins/delete',
  // Quản trị điểm bình chọn (backend src/vote/vote-admin.controller.ts): xem ADMIN/MOD, sửa chỉ ADMIN.
  voteAdminEntries: (voteId: number | string) => `/vote-admin/${voteId}/entries`,
  voteAdminLogs: (voteId: number | string) => `/vote-admin/${voteId}/logs`,
  voteAdminAdjust: (entryId: number) => `/vote-admin/entries/${entryId}/adjust`,
  voteAdminReset: (voteId: number | string) => `/vote-admin/${voteId}/reset`,
  voteAdminRemove: (voteId: number | string) => `/vote-admin/${voteId}/remove`,

  // GALA (hp-media-server-staging/src/gala). Phần quản trị chỉ ADMIN; đường dẫn con ghép trong pages/gala/api.ts.
  gala: '/gala',
  galaAdmin: '/gala/admin',

  //rules
  rules: '/rules',
  putRules: '/rules',

  //store

  stores: '/stores/admin',
  createStore: '/stores',
  updateStore: '/stores',
  deleteStore: '/stores/delete',

  //outstanding

  outstanding: '/outstanding/admin',
  outstandingCreate: '/outstanding',
  outstandingUpdate: '/outstanding',
  outstandingDelete: '/outstanding/delete',

  //country
  listCountry: '/country/settings',
  updateCountry: '/country/settings',
  deleteCountry: '/country/settings/delete',

  ///revenues
  revenues: '/revenues',
  revenueDelete: '/revenues/delete',

  //attendance
  attendanceList: '/attendance/list',
  attendanceExportExcel: '/attendance/admin/export-excel',
  attendanceExportExcelAll: '/attendance/admin/export-excel/all',
  // Admin manual attendance ops — append `/${id}` for edit and `/${id}/history` for history
  attendanceAdmin: '/attendance/admin',
  attendanceShifts: '/attendance/shifts',
  attendanceDepartments: '/attendance/departments',
  departments: '/departments',
  leaveTypes: '/leave/types',
  leaveRequests: '/leave/requests',

  //overtime
  overtimeRequests: '/overtime/requests',

  //payslips
  payslips: '/payslips',
  payrollTimesheetDefaults: '/payroll/admin/timesheet/defaults',
  payrollTimesheetExport: '/payroll/admin/timesheet/export',
  //settings

  settings: '/settings',

  //assignments
  assignments: '/attendance/assignments',
  generateAssignments: '/attendance/assignments/generate',

  //sounds
  sounds: '/sounds/admin',
  createSounds: '/sounds/create',
  editSound: 'sounds',
  deleteSounds: '/sounds/delete',

  //pk
  pks: '/pks',
  updatePK: '/pks',
  deletePK: '/pks/delete',

  //convesations

  createConversation: 'conversations',

  //liveshows
  liveShow: '/live-shows',
  jobNotification: '/job-notifications',
  deleteShow: '/live-shows/delete',
  createShow: '/live-shows',
  liveSupportAdmin: '/live-support/admin',
  //requestIdol
  requestIdol: '/idols/requests',
  updateRequestIdol: '/idols/requests',

  //job

  createJob: '/job-notifications',
  deleteJob: '/job-notifications/delete',

  //notification

  pushNotification: '/notifications/all',
  adminNotification: '/notifications/admin',
  deleteNotification: '/notifications/delete',

  //banners
  banners: '/banners',
  updateBanners: '/banners',
  deleteBanners: '/banners/delete',

  //menus
  menus: '/menus/admin',
  updateMenu: '/menus',
  deleteMenu: '/menus/delete',
  menuGroups: '/menus/groups',
  menuGroupsOrder: '/menus/groups/order',

  //ads
  ads: '/ads',
  listAds: '/image-ads',
  postAds: '/image-ads',
  deleteAds: '/image-ads/delete',
  // PATCH /image-ads/:id sửa ảnh/liên kết/lịch chạy; PUT /image-ads/:id bật/tạm dừng.
  editAds: '/image-ads',

  //group live show
  groupShow: '/group-shows',
  groupShowList: '/group-shows/list',
  groupShowDel: '/group-shows/delete',

  //stars (Điểm Sao) — admin, xem docs/nghien-cuu-diem-sao/SPEC-TRIEN-KHAI-DIEM-SAO.md §4b
  starsDashboard: '/stars/admin/dashboard',
  starsConfig: '/stars/admin/config',
  starsAccounts: '/stars/admin/accounts',
  starsAdjust: '/stars/admin/adjust',
  starsLedger: '/stars/admin/ledger',
  starsMissions: '/stars/admin/missions',
  starsMissionReviews: '/stars/admin/missions/reviews',
  starsMissionRun: '/stars/admin/missions/run',
  starsKc: '/stars/admin/kc',
  starsKcManual: '/stars/admin/kc/manual',
  starsKcEvaluate: '/stars/admin/kc/evaluate',
  starsItems: '/stars/admin/items',
  starsOrders: '/stars/admin/orders',
  starsPenaltyTypes: '/stars/admin/penalty-types',
  starsPenalties: '/stars/admin/penalties',
  // Nhiệm vụ mở rộng — docs/nghien-cuu-diem-sao/SPEC-NHIEM-VU-MO-RONG.md §3.3, §4.3, §6
  starsMissionTemplates: '/stars/admin/missions/templates',
  starsRecruits: '/stars/admin/recruits',
  starsRecruitCandidates: '/stars/admin/recruits/candidates',
  starsDanceSessions: '/stars/admin/dance/sessions',

  // Hộp thư hỗ trợ — ADMIN + MOD (hp-media-server-staging/src/support/support-admin.controller.ts)
  supportMeta: '/support/admin/meta',
  supportSummary: '/support/admin/summary',
  supportNotifications: '/support/admin/notifications',
  supportAgents: '/support/admin/agents',
  supportThreads: '/support/admin/threads',
  supportStart: '/support/admin/start',
  supportBulkOpen: '/support/admin/bulk-open',
  supportNotes: '/support/admin/notes',
  supportTemplates: '/support/admin/templates',
  supportConfig: '/support/admin/config',
  supportConfigAccount: '/support/admin/config/account',

  // Watermark chống lộ — hp-media-server-staging/src/watermark. me: mọi người đăng nhập;
  // admin/*: ADMIN + MOD, PUT config chỉ ADMIN (400 WATERMARK_ADMIN_ONLY, không 401/403).
  watermarkMe: '/watermark/me', // ?surface=admin
  watermarkConfig: '/watermark/admin/config',
  watermarkLookup: '/watermark/admin/lookup', // ?code=

  // [Phiên "Tổ chức lại nhóm và quyền" 29/09] Nhóm người · Quyền hạn · Xác nhận nhân viên —
  // docs/to-chuc-lai-nhom-quyen/00-ban-do-va-phuong-an-2026-09-29.md §4.4, §5.3.
  // Lỗi nghiệp vụ trả 400/404/409/503 kèm mã ở `message` (không 401/403).
  memberTypesOverview: '/member-types/overview', // GET — ADMIN + MOD
  memberTypesUsers: '/member-types/users', // GET ?type=&page=&limit=&q= — chỉ ADMIN
  approvalPermissions: '/approvals/permissions', // GET (ai có cấp duyệt) · PUT { changes, reason } (ADMIN)
  approvalPermissionsReset: '/approvals/permissions/reset', // POST { reason } (ADMIN)
  staffAccessSummary: '/staff-access/admin/summary', // staff-access/*: chỉ ADMIN
  staffAccessClaims: '/staff-access/admin/claims', // GET ?status=&page=&limit=&q= · POST /:id/approve · /:id/reject · /bulk
  staffAccessReview: '/staff-access/admin/review', // GET ?tab=LEGACY|OPS&page=&limit=&q=
  staffAccessConfirm: '/staff-access/admin/confirm', // POST { userIds, note? }
  staffAccessRevoke: '/staff-access/admin/revoke', // POST { userId, note }
  staffAccessConfig: '/staff-access/admin/config', // PUT { mode, reason }
  // [hết phần của phiên "Tổ chức lại nhóm và quyền"]

  // Bảng tin nội bộ — hp-media-server-staging/src/feed (docs/bang-tin/01-backend.md §5–6,
  // docs/bang-tin/03-admin.md). ADMIN + MOD; việc chỉ ADMIN trả 409 FEED_ADMIN_ONLY (không 401/403).
  feedAdminMeta: '/feed/admin/meta',
  feedAdminSummary: '/feed/admin/summary',
  feedAdminPosts: '/feed/admin/posts', // + /:id · /:id/{hide|unhide|approve|reject|delete|pin|unpin} (/:id/reads: GĐ2)
  feedAdminComments: '/feed/admin/comments', // + /:id/{hide|unhide|approve|reject|delete}
  feedAdminReports: '/feed/admin/reports',
  feedAdminReportItems: '/feed/admin/reports/items',
  feedAdminReportsResolve: '/feed/admin/reports/resolve',
  feedAdminRestrictions: '/feed/admin/restrictions', // + /:id/revoke
  feedAdminLogs: '/feed/admin/logs',
  feedAdminSettings: '/feed/admin/settings',
  feedAdminBannedWords: '/feed/admin/banned-words', // + /:id (PATCH, DELETE)
  feedAdminBannedWordsImport: '/feed/admin/banned-words/import',
  feedAdminTestText: '/feed/admin/moderation/test-text',
  feedAdminTestImage: '/feed/admin/moderation/test-image', // GĐ1b — chỉ ADMIN
  feedAdminMaintenance: '/feed/admin/maintenance/run',
  feedAdminMembers: '/feed/admin/members', // GET ?status=active|candidates|revoked · POST cấp { userIds, note? }
  feedAdminMembersRevoke: '/feed/admin/members/revoke',
  feedAdminPageEditors: '/feed/admin/page-editors', // GET · POST { userId, note? } · DELETE /:userId
  feedAdminTiktokFollowers: '/feed/admin/tiktok-followers', // PUT /:userId (tổng follower + ngày đo từ nguồn xác thực)
  feedAdminBlocksSummary: '/feed/admin/blocks/summary',
  feedAdminTermsVersions: '/feed/admin/terms/versions',
  feedAdminMediaFile: '/feed/admin/media', // + /:id/file?v=original|preview — file private (đã bị gỡ), tải bằng axios blob
  // API của app — admin dùng để đăng bài tên "HP Media" (cùng cookie phiên).
  feedMeAccess: '/feed/me/access',
  feedTerms: '/feed/terms',
  feedTermsAccept: '/feed/terms/accept',
  feedPosts: '/feed/posts', // + /:id/important (POST, DELETE)
  feedMediaImages: '/feed/media/images',
  feedMediaVideo: '/feed/media/video',
  feedMedia: '/feed/media', // + /:id (GET trạng thái, DELETE)

  // Studio — hp-media-server-staging/src/studios (docs/studio-quan-ly/SPEC-TRIEN-KHAI-STUDIO.md §8.11).
  // Sai quyền / ngoài phạm vi trả 409 kèm mã STUDIO_* (không 401/403).
  // Cùng giá trị với STUDIO_URLS trong pages/studio/api.ts (hai nơi phải giữ khớp).
  studiosMine: '/studios/mine',
  studios: '/studios', // GET danh sách · POST tạo
  studioManagerCandidates: '/studios/manager-candidates',
  studioCandidates: '/studios/candidates', // ?q=&studioId= — ô chọn thành viên, không có email
  studio: (id: number) => `/studios/${id}`, // GET · PATCH · DELETE · + /manager /overview /members /teams /kc /log /flags /requests
  studioRequests: '/studios/requests', // GET lịch sử · + /:id/approve /:id/reject /:id/cancel /:id/apply
  studioRequestsSummary: '/studios/requests/summary',
  studioRequestsQueue: '/studios/requests/queue',
  studioRequestsBulk: '/studios/requests/bulk',
  studioMonitorSummary: '/studios/monitor/summary',
  studioMonitorFlags: '/studios/monitor/flags',
  studioMonitorLog: '/studios/monitor/log',
  // Duyệt nhanh — hp-media-server-staging/src/approvals/api/approvals.controller.ts
  // (approvalsMe đã khai ở khối Nhập dữ liệu phía trên.)
  approvalsSummary: '/approvals/summary', // ?studioId=
  approvalsQueue: '/approvals/queue', // ?kind=&studioId=&page=&limit=
  approvalsBulk: '/approvals/bulk',
  approvalsFlags: '/approvals/flags', // + /:id (PATCH khép cờ)
  approvalsLog: '/approvals/log', // + /:id/dispute
};
